export type notifiactionType = 'successful' | 'warning' | 'error';

export class Notification {
    visible: boolean;
    text: string;
    undertext: string;
    type: notifiactionType;

    constructor(visible: boolean, text: string, undertext?: string, type?: notifiactionType) {
        this.visible = visible;
        this.text = text;
        this.undertext = undertext === undefined ? '' : undertext;
        this.type = type === undefined ? Notification.defaultType() : type;
    }

    static defaultType(): notifiactionType {
        return 'successful';
    }

    static emptyNotification(): Notification {
        return { visible: false, text: '', undertext: '', type: Notification.defaultType() };
    }
}